import gql from 'graphql-tag'

export const MENU_SUB_NAVIGATION_ITEM_FRAGMENT = gql`
  fragment MenuSubNavItem on MenuSubNavigationItem {
    displayName
    url
    isInFooter
  }
`

export const MENU_NAVIGATION_ITEM_FRAGMENT = gql`
  ${MENU_SUB_NAVIGATION_ITEM_FRAGMENT}

  fragment MenuNavItem on MenuNavigationItem {
    displayName
    isSelected
    iconName
    html
    inVariant
    subNavigationItems {
      ...MenuSubNavItem
    }
    url
  }
`

export const GET_MAIN_NAVIGATION = gql`
  ${MENU_NAVIGATION_ITEM_FRAGMENT}

  query GetMainNavigation($uri: String!) {
    mainNavigation(uri: $uri) {
      menuItems {
        ...MenuNavItem
      }
    }
  }
`
